module.exports = __webpack_public_path__ + "img/001.44e8ac2e.jpg";